import {Component} from '@angular/core';
import {App, NavController, NavParams, ToastController} from 'ionic-angular';
import {StorageService} from "../../providers/storage";
import {GetNewsService} from "../../providers/get-news-service";
import {FeedPage} from "../feed/feed";

/*
 Generated class for the Settings page.

 Ionic pages and navigation.
 */
@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html'
})
export class SettingsPage {
  public settings = {
    pushEnabled: true,
    foreAlarm: true,
    titleSize: 'Normale',
    textSize: 'Normale',
    showKeywords: true
  };
  appVersion;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storageService: StorageService,
    private getNewsService: GetNewsService,
    private toastCtrl: ToastController,
    private app: App
  ) {}

  ionViewDidLoad() {
    // console.log('ionViewDidLoad SettingsPage');
  }

  ngOnInit() {
    this.settings.pushEnabled = this.storageService.get('pushEnabled') === 'true';
    this.settings.foreAlarm = this.storageService.get('foreAlarm') === 'true';
    this.settings.titleSize = this.storageService.get('titleSize');
    this.settings.textSize = this.storageService.get('textSize');
    this.settings.showKeywords = this.storageService.get('showKeywords') === 'true';
    this.appVersion = this.storageService.get('app_version')
  }

  saveSettings(settings) {
    this.getNewsService.saveSettings(settings.showKeywords, settings.foreAlarm, settings.textSize, settings.titleSize).subscribe(
      (data) => {
        let toast = this.toastCtrl.create({
          message: 'Impostazioni salvate con successo',
          duration: 3000
        });
        this.storageService.set('showKeywords', settings.showKeywords);
        this.storageService.set('foreAlarm', settings.foreAlarm);
        this.storageService.set('textSize', settings.textSize);
        this.storageService.set('titleSize', settings.titleSize);
        toast.present();
        let nav = this.app.getActiveNavs()[0];
        nav.setRoot(FeedPage);
      },
      err => {
        console.log(err)
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts